export default __webpack_public_path__ + "static/media/success.69c0bc5e.svg";